import type {
  IBaseMaterialManageDataType,
  IBrandPlankItem,
  IBrandPlankLoadInfo,
  IBrandPlankParams,
  ISaveBrandPlankListParams,
} from '@/apis/baseMaterial/type'
import { httpRequest } from '@/apis/request'
import type { FromGuimen, response } from '@/apis/types'
import { isBrandRecord } from '@/util/brandPlankIdentity'

enum Apis {
  layoutData = 'get_layout_data',
  baseMaterial = 'load_plank_manage_setting_info',
  brandPlank = 'board/bluen_color_info',
}

export function getLayoutData(data: { room_ids: number[] }) {
  return httpRequest.post(Apis.layoutData, data)
}

export function getRawMaterialPlankInfo(params: { uid: number } & FromGuimen) {
  return httpRequest.post<response<IBaseMaterialManageDataType>>(
    Apis.baseMaterial,
    params
  )
}

export function fetchBrandPlankList(params: IBrandPlankParams) {
  return httpRequest.get<response<IBrandPlankItem[]>>(Apis.brandPlank, params)
}

export function saveBrandPlankList(params: ISaveBrandPlankListParams) {
  return httpRequest.put<response<unknown>>(Apis.brandPlank, params)
}

export async function loadFullPlankManageData(
  params: IBrandPlankParams
): Promise<
  response<IBaseMaterialManageDataType> & {
    brandPlankLoad: IBrandPlankLoadInfo
  }
> {
  const standardRes = await getRawMaterialPlankInfo(params)

  if (standardRes.status !== 1) {
    return {
      ...standardRes,
      brandPlankLoad: { state: 'skipped' },
    }
  }

  const nonBrandSpecialPlanks = (
    standardRes.data.specialPlankInfo || []
  ).filter((plank) => !isBrandRecord(plank))
  let brandPlanks: IBrandPlankItem[] = []
  let brandPlankLoad: IBrandPlankLoadInfo = { state: 'loaded' }

  try {
    const brandRes = await fetchBrandPlankList(params)
    if (brandRes.status === 1) {
      brandPlanks = brandRes.data || []
    } else {
      brandPlankLoad = {
        state: 'failed',
        message: brandRes.msg || '品牌大板加载失败',
      }
    }
  } catch {
    brandPlankLoad = {
      state: 'failed',
      message: '品牌大板加载失败',
    }
  }

  return {
    ...standardRes,
    brandPlankLoad,
    data: {
      ...standardRes.data,
      // 品牌大板合并进特殊大板列表，供排版匹配/预排版设置/历史等流程使用（品牌大板无 id）
      // 修边检查在 checkPlankEdgeHasChanged 内区分处理：普通特殊大板按 id 匹配，品牌大板按 color_id 匹配
      specialPlankInfo: [...nonBrandSpecialPlanks, ...brandPlanks],
    },
  }
}
